/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * OutOfStockOrderTemplateLines Input Action
 */
export class OutOfStockOrderTemplateLinesInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `OutOfStockOrderTemplateLines`;
    public getCacheObjectType = () => 'OutOfStockOrderTemplateLinesObject';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IOutOfStockOrderTemplateLinesData {
    outOfStockItems: string[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new OutOfStockOrderTemplateLinesInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: OutOfStockOrderTemplateLinesInput, ctx: Msdyn365.IActionContext): Promise<IOutOfStockOrderTemplateLinesData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IOutOfStockOrderTemplateLinesData[]>('/get/example/id/1', 'get');
    return { outOfStockItems: [] };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IOutOfStockOrderTemplateLinesData>>action,
    // TODO: Give your data action a unique id
    id: 'OutOfStockOrderTemplateLines',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
